var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6193 8.99996L12.4345 10.8153C12.7441 11.1248 12.7441 11.6259 12.4345 11.9347C12.125 12.2434 11.6239 12.2442 11.3151 11.9347L9.49984 10.1194L7.68455 11.9347C7.375 12.2442 6.87388 12.2442 6.56513 11.9347C6.25638 11.6251 6.25559 11.124 6.56513 10.8153L8.38042 8.99996L6.56513 7.18467C6.25559 6.87513 6.25559 6.374 6.56513 6.06525C6.87467 5.7565 7.3758 5.75571 7.68455 6.06525L9.49984 7.88054L11.3151 6.06525C11.6247 5.75571 12.1258 5.75571 12.4345 6.06525C12.7433 6.37479 12.7441 6.87592 12.4345 7.18467L10.6193 8.99996ZM9.49984 17.7083C4.69046 17.7083 0.791504 13.8093 0.791504 8.99996C0.791504 4.19058 4.69046 0.291626 9.49984 0.291626C14.3092 0.291626 18.2082 4.19058 18.2082 8.99996C18.2082 13.8093 14.3092 17.7083 9.49984 17.7083ZM9.49984 16.125C13.4352 16.125 16.6248 12.9353 16.6248 8.99996C16.6248 5.06458 13.4352 1.87496 9.49984 1.87496C5.56446 1.87496 2.37484 5.06458 2.37484 8.99996C2.37484 12.9353 5.56446 16.125 9.49984 16.125Z",
    fill: "#D62E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.7ada0fb6b850237cf7f6aa0d4054478f.svg";
export { ForwardRef as ReactComponent };